import {
  editDiscussionCommentsReplies,
  reactDiscussionCommentReplies,
  setRoomEditData,
} from '@/actions/room';
import AvatarComponent from '@/components/common/avatar';
import {
  calculateTopThreeEmojisUsed,
  calculateTotalCountLikes,
} from '@/helpers/dataHelper';
import formDataHelper from '@/helpers/formDataHelper';
import { emojis, getReactColor } from '@/helpers/index';
import { CloseOutlined, SendOutlined } from '@ant-design/icons';
import { Button, Dropdown, Typography } from 'antd';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { Spinner } from 'reactstrap';

const { Text } = Typography;

const RepliesSection = ({
  replyState,
  comment,
  replies,
  replyEditId,
  CommentMenu,
  setReplyState,
  user,
  replyText,
  handleAddReplies,
  setReplyText,
  commentUserName,
  setIsReplyReaction,
  setReactionRepliesData,
  setEmojiCountModal,
  setReactionReplyId,
  editReplyText,
  setEditRepyText,
  setReplyEditId,
}) => {
  const dispatch = useDispatch();

  const onReplyLikeClick = (replyId, commentId, reaction) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'commentId',
        value: commentId,
      })
    );
    const values = {
      reply: replyId,
      reaction,
    };

    const value = formDataHelper(values, {});

    dispatch(reactDiscussionCommentReplies({ data: value }));
  };

  const editCommentReplyApi = (commentId) => {
    dispatch(
      setRoomEditData({
        name: 'discussionComments',
        key: 'commentId',
        value: commentId,
      })
    );
    var data = {
      text: editReplyText,
    };
    dispatch(editDiscussionCommentsReplies({ data, replyId: replyEditId }));
  };

  return (
    <>
      {replyState.open[comment?.id] && (
        <div>
          <div className="d-flex justify-content-end mb-1">
            <CloseOutlined
              rev=""
              style={{
                fontSize: '12px',
              }}
              onClick={() => {
                setReplyState({
                  open: {
                    ...replyState.open,
                    [comment?.id]: false,
                  },
                });
              }}
              className="float-right cursor-pointer close-comment"
            />
          </div>
          <div className="d-flex reply-write-content  align-items-center">
            <div className="mr-2">
              <AvatarComponent
                avatar={user?.avatar}
                size={36}
                firstName={user?.first_name}
                lastName={user?.last_name}
              />
            </div>
            <div className="position-relative w-100">
              <textarea
                value={replyText[comment.id] && replyText[comment.id]?.value}
                onChange={(e) => {
                  setReplyText({
                    ...replyText,
                    [comment.id]: {
                      id: comment.id,
                      value: e.target.value,
                    },
                  });
                }}
                placeholder={`Reply to ${commentUserName}. . .`}
                className="text-area w-100 pl-3 pr-5 py-2 border-0 "
                style={{
                  borderRadius: '25px',
                  height: '40px',
                  resize: 'none',
                  backgroundColor: 'rgb(240, 242, 245)',
                }}
              ></textarea>
              <SendOutlined
                rev=""
                className={`position-absolute ${
                  replyText[comment.id]?.value?.length > 0
                    ? 'cursor-pointer'
                    : 'cursor-disabled'
                }`}
                style={{
                  top: '12px',
                  right: '10px',
                  fontSize: '15px',
                  color: `${replyText[comment.id]?.value ? '#283360' : ''}`,
                }}
                disabled={replyText[comment.id]?.value?.length === 0}
                onClick={() =>
                  replyText[comment.id]?.value?.length > 0 &&
                  handleAddReplies(comment?.id)
                }
              />
            </div>
          </div>
          {replies[comment?.id]?.getRoomDiscussionCommentReplies === 'request' ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="border" className="mt-3" />
            </div>
          ) : (
            replyState.open[comment?.id] &&
            replies[comment?.id]?.data?.length !== 0 &&
            replies[comment?.id]?.data?.map((reply, i) => (
              <div className="comment-item align-items-stretch pt-2 d-flex" key={i}>
                <div className="comment-left position-relative">
                  <AvatarComponent
                    size={36}
                    firstName={reply?.created_by?.first_name}
                    lastName={reply?.created_by?.last_name}
                    avatar={reply?.created_by?.avatar}
                  />
                </div>
                <div className={`comment-content `}>
                  {replyEditId !== reply.id && (
                    <div className="d-flex justify-content-start">
                      <div>
                        <div
                          className="py-1 px-2 position-relative "
                          style={{
                            backgroundColor: 'rgb(240, 242, 245)',
                            borderRadius: '14px',
                          }}
                        >
                          <Text style={{ fontWeight: '600' }}>
                            {reply?.created_by?.first_name}{' '}
                            {reply?.created_by?.last_name}
                          </Text>
                          <p
                            className="text-justify m-0"
                            style={{
                              wordBreak: 'break-all',
                            }}
                          >
                            {reply?.text}
                          </p>
                          {(reply?.reaction?.length > 0 ||
                            reply?.no_of_likes > 0) && (
                            <div
                              className={`position-absolute bg-primary text-white px-1 cursor-pointer`}
                              style={{
                                borderRadius: '10px',
                                right: '-29px',
                                bottom: '0',
                              }}
                              onClick={() => {
                                setIsReplyReaction(true);
                                setReactionRepliesData(reply?.reaction);
                                setReactionReplyId(reply?.id);
                                setEmojiCountModal(true);
                                dispatch(
                                  setRoomEditData({
                                    name: 'repliesReactionList',
                                    key: 'replyId',
                                    value: reply?.id,
                                  })
                                );
                              }}
                            >
                              <span>
                                {reply?.reaction
                                  ? calculateTopThreeEmojisUsed(
                                      reply?.reaction
                                    )?.map((el) =>
                                      emojis?.map((em) => {
                                        if (el?.reaction === em?.title)
                                          return em?.value;
                                      })
                                    )
                                  : emojis[0].value}
                              </span>
                              <span className={`ml-1`}>
                                {reply?.reaction?.length
                                  ? calculateTotalCountLikes(reply?.reaction)
                                  : reply?.no_of_likes}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="comment-controls d-flex gap-3 justify-content-start align-items-center">
                          <span className="d-time light-text">
                            {moment(reply?.created_at).fromNow()}
                          </span>
                          <div className="like-count d-flex justify-content-start align-items-center cursor-pointer">
                            <div className="position-relative ">
                              <span
                                className="reply--like"
                                // onMouseOver={() => showPopup(false, true, false)}
                                // onMouseOut={() => hidePopup(false, true, false)}
                              >
                                {reply?.user_reaction || reply?.like ? (
                                  reply?.user_reaction ? (
                                    emojis?.map((el) => {
                                      if (reply?.user_reaction === el?.title)
                                        return (
                                          <span
                                            onClick={() =>
                                              onReplyLikeClick(
                                                reply?.id,
                                                comment?.id,
                                                reply?.user_reaction
                                              )
                                            }
                                            className={`cursor-pointer ${getReactColor(
                                              reply?.user_reaction
                                            )}`}
                                            style={{
                                              fontWeight: '600',
                                            }}
                                          >
                                            {el?.slug}
                                          </span>
                                        );
                                    })
                                  ) : (
                                    <span
                                      className="text-primary cursor-pointer"
                                      onClick={() =>
                                        onReplyLikeClick(
                                          reply?.id,
                                          comment?.id,
                                          'LIKE'
                                        )
                                      }
                                      style={{
                                        fontWeight: '600',
                                      }}
                                    >
                                      Like
                                    </span>
                                  )
                                ) : (
                                  <span
                                    onClick={() =>
                                      onReplyLikeClick(
                                        reply?.id,
                                        comment?.id,
                                        'LIKE'
                                      )
                                    }
                                    style={{
                                      fontWeight: '600',
                                    }}
                                  >
                                    Like
                                  </span>
                                )}
                                <div className="position-absolute bg-primary px-2 reply--like__react align-items-center m-auto ">
                                  {emojis?.map((el, i) => (
                                    <span
                                      key={i}
                                      style={{
                                        fontSize: '19px',
                                      }}
                                      className={`${
                                        emojis?.length === i + 1 ? '' : 'mr-2 '
                                      } cursor-pointer like--react__icons d-block`}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onReplyLikeClick(
                                          reply?.id,
                                          comment?.id,
                                          el?.title
                                        );
                                      }}
                                    >
                                      {el?.value}
                                    </span>
                                  ))}
                                </div>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ml-auto">
                        {user?.id === reply.created_by.id ? (
                          <Dropdown
                            overlay={
                              <CommentMenu
                                comment={reply}
                                each={comment}
                                isComment={false}
                              />
                            }
                            placement="bottomLeft"
                            className="dropdown-ml ml-auto edit-reply-button "
                            trigger={['click']}
                            overlayStyle={{
                              minWidth: '160px',
                            }}
                          >
                            <div className="edit-post-button">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <circle cx="12" cy="12" r="1"></circle>
                                <circle cx="12" cy="5" r="1"></circle>
                                <circle cx="12" cy="19" r="1"></circle>
                              </svg>
                            </div>
                          </Dropdown>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  )}
                  {replyEditId === reply.id && (
                    <div className="mb-2 reply-write-content">
                      <textarea
                        value={editReplyText}
                        onChange={(e) => {
                          setEditRepyText(e.target.value);
                        }}
                        placeholder="Edit your reply here..."
                        className="text-area w-100 p-2 border-0 "
                        style={{
                          resize: 'none',
                          borderRadius: '14px',
                          backgroundColor: 'rgb(240, 242, 245)',
                        }}
                      ></textarea>
                      <div className="d-flex align-items-center justify-content-end gap-3">
                        <Button
                          loading={
                            replies[comment?.id].editRoomDiscussionCommentReplies ===
                            'request'
                              ? true
                              : false
                          }
                          className="d-flex btn-sm btn-primary border-danger mt-2 align-items-start"
                          onClick={() => editCommentReplyApi(comment?.id)}
                          disabled={editReplyText.length > 0 ? false : true}
                        >
                          Save
                        </Button>
                        <Button
                          className="d-flex btn-sm btn-secondary border-danger mt-2 align-items-start"
                          onClick={() => setReplyEditId(null)}
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </>
  );
};

export default RepliesSection;
